// extracted by mini-css-extract-plugin
export default {"footerContent":"FooterContent_footerContent__k3y4J","absoluteOverlay":"FooterContent_absoluteOverlay__xNEa5"};